import React, { useContext } from 'react';
import AuthContext from '../context/AuthContext';
import LanguageSelector from './LanguageSelector';
import TimezoneSelector from './TimezoneSelector';
import '../styles/general.css';

const TopBar = () => {
  const { user } = useContext(AuthContext);

  return (
    <nav className="topbar">
      <div className="topbar-actions">
        <TimezoneSelector />
        <LanguageSelector />
        <div className="topbar-user">
          {user?.email}
        </div>
      </div>
    </nav>
  );
};

export default TopBar;
